module.exports = __webpack_public_path__ + "static/media/sept 2021.7bb2c2c5.svg";